import { render, staticRenderFns } from "./ServerSelector.vue?vue&type=template&id=f413800a"
import script from "./ServerSelector.vue?vue&type=script&lang=js"
export * from "./ServerSelector.vue?vue&type=script&lang=js"
import style0 from "./ServerSelector.vue?vue&type=style&index=0&id=f413800a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports